<template>
  <s-text-editor
    ref="textEditor"
    :error-text="$t('sTextEditor.contentRequired')"
    class="mt-4"
  />
</template>

<script>
import STextEditor from '../../../components-shared/utils/STextEditor.vue'
import _ from 'lodash'
import BookingStates from '../../../classes-shared/bookings/BookingStates'
import Basket from '../../../classes-shared/basket/Basket'
import User from '../../../classes-shared/user/User'
import UserBookings from '../../../classes-shared/bookings/UserBookings'
import MailText from './MailText'

export default {
  name: 'MailCompose',
  components: { STextEditor },
  props: {
    user: {
      required: false,
      default: null,
      type: [User, UserBookings],
    },
    basket: {
      required: false,
      default: null,
      type: [Basket, null],
    },
    bookingStates: {
      required: false,
      default: null,
      type: [BookingStates, null],
    },
  },
  computed: {
    currentAppLanguage() {
      return this.$store.getters.getActualI18n()
    },
  },
  watch: {
    // compose mail text
    user() {
      this.composeMailText()
    },
    // compose mail text
    basket: {
      handler() {
        this.composeMailText()
      },
      deep: true,
    },
    // trigger compose mail text
    bookingStates: {
      handler() {
        this.composeMailText()
      },
      deep: true,
    },
    currentAppLanguage() {
      this.composeMailText()
    },
  },
  methods: {
    composeMailText() {
      if (this.user && this.basket && this.basket.getBasketEntries().length) {
        const salutation = this.generateSalutation()
        const bookingList = this.generateBookingList()
        const entryLine = this.generateEntryLine()
        const closingLine = this.generateClosingLine()
        const greetings = this.generateGreetings()
        const mailText =
          '<p>' +
          salutation +
          '</p>' +
          entryLine +
          bookingList +
          closingLine +
          greetings
        // send text to editor
        this.$refs.textEditor.setContent(mailText)
      }
      // no mail text can be generated because of missing user input
      return null
    },
    generateSalutation() {
      const salutationKey = this.user.salutations.salutation.salutationKey
      let salutation = this.getTextElement('salutationN')
      if (salutationKey === 'm')
        salutation =
          this.getTextElement('salutationM') + ' ' + this.user.getLastName()
      else if (salutationKey === 'f')
        salutation =
          this.getTextElement('salutationF') + ' ' + this.user.getLastName()
      else salutation = salutation + ' ' + this.user.getFullName()
      return salutation
    },
    generateEntryLine() {
      if (this.bookingStates.isReserved()) {
        return this.getTextElement('entryLineReserved')
      } else if (this.bookingStates.isWaitingList()) {
        return this.getTextElement('entryLineWaitingList')
      } else {
        return this.getTextElement('entryLineConfirmed')
      }
    },
    generateBookingList() {
      // generate booking list
      let bookingList = '<ul>'
      let basketEntriesGroupedBy = _.groupBy(
        this.basket.getBasketEntries(),
        (basketEntry) => basketEntry.getProductDefinitionId()
      )
      // sort entries
      basketEntriesGroupedBy = _.sortBy(
        basketEntriesGroupedBy,
        (basketEntries) =>
          basketEntries[0]
            .getProductDefinitionInstance()
            .getProductInstance()
            .getSortOrder()
      )
      const on = this.getTextElement('on')
      for (let group in basketEntriesGroupedBy) {
        const basketEntriesGroup = basketEntriesGroupedBy[group]
        const amount = basketEntriesGroup.length
        const basketEntry = basketEntriesGroup[0]
        bookingList =
          bookingList +
          '<li><p>' +
          amount +
          'x ' +
          basketEntry.getTitle() +
          ' (' +
          this.$t(basketEntry.getProductDefinitionInstance().getTranslation()) +
          ') ' +
          on +
          ' ' +
          basketEntry.getFormatedDate() +
          '</p></li>'
      }
      return bookingList + '</ul>'
    },
    generateClosingLine() {
      if (this.bookingStates.isReserved()) {
        return this.getTextElement('closingLineReserved')
      } else if (this.bookingStates.isWaitingList()) {
        return this.getTextElement('closingLineWaitingList')
      } else {
        return this.getTextElement('closingLineConfirmed')
      }
    },
    generateGreetings() {
      return `${this.getTextElement(
        'greetings'
      )} <p>${this.$store.getters.getAppUserInstance().getFullName()}</p>`
    },
    getTextElement(key) {
      const destination = this.$store.getters
        .getCurrentDestinationInstance()
        .getSlug()
      return MailText.getTextElement(destination, key, this.currentAppLanguage)
    },

    // GETTERS for parent components
    validate() {
      return this.$refs.textEditor.validate()
    },
    getMailText() {
      return this.$refs.textEditor.getContent()
    },
  },
}
</script>
